export const FIREBASE_COLLECTION = 'faq';
export const SUB_COLLECTION = 'products';
